<section id="board">
    <button class="back-btn" (click)="back()" ><i class="fa fa-backward"><span> BACK</span></i></button>
    <div class="container">
        <div class="inner-container">
            <div class="thrift">
                <img *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <a routerLink="/create-thrift">
                    <img *ngIf="!loading"  src="./assets/thrift.jpg" alt="" srcset="">
               </a>
                <h3 *ngIf="!loading">Create thrift</h3>
            </div>
            <div class="campaign">
                
                <img  *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <a routerLink="/join-thrift">
                <img *ngIf="!loading" src="./assets/campaign.jpg" alt="" srcset="">
                </a>
                <h3 *ngIf="!loading">Join A Thrift</h3>
            </div>
            <div class="campaign">
                <img  *ngIf="loading" style="width: 80%;" (load)="onLoad()" src="/assets/loader.gif" alt="loading" />
                <img *ngIf="!loading" src="./assets/campaign.jpg" alt="" srcset="">
                <h3 *ngIf="!loading">Active/Pending Thrift</h3>
            </div>
            
            
        </div>
        
    </div>



</section>